// CONSTANTS are all caps.
const NS = 'ImageGalleryBlock';
const CLS = 'imageGalleryBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
// import rImageGalleryBlock from './ImageGalleryBlock.jsx';
// import React from 'react';
// import ReactDOM from 'react-dom';

export class ImageGalleryBlock {
	constructor(element) {
		// $el is the blk node return by the loadImageGalleryBlock function
		this.$el = $(element);
	}

	init() {
		this.setImageGalleryBlock();

		console.log(123);
		let list = this.$el.find('.imageGalleryBlock-slide');
		if(list.length <= 1) {
			this.$el.addClass('noArrow');
		}
	}

	setImageGalleryBlock() {
		// Add Some logic here
		const $prevArrow = this.$el.find(`.${CLS}-arrow--prev`);
		const $nextArrow = this.$el.find(`.${CLS}-arrow--next`);
		const $slider = this.$el.find(`.${CLS}-slider`);
		const slickOptions = {
			autoPlay: true,
			arrows: true,
			mobileFirst: true,
			prevArrow: $prevArrow,
			nextArrow: $nextArrow,
			dots: true,
		};
		$slider.slick(slickOptions);
	}

	// Add more functions like on above here
}
